import React, { useState, useRef, useEffect } from 'react';
import { useOrganization } from '../context/OrganizationContext';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export default function OrganizationSwitcher() {
  const { organizations, currentOrganization, setCurrentOrganization } = useOrganization();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOrgSelect = async (orgId) => {
    const org = organizations.find(o => o.id === orgId);
    if (org) {
      setCurrentOrganization(org);
      setIsOpen(false);
    }
  };

  if (!currentOrganization) return null;

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded hover:bg-gray-300/50 dark:hover:bg-dark-300 transition-colors"
      >
        <span className="text-sm text-gray-700 dark:text-gray-300">{currentOrganization.name}</span>
        <ChevronDownIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white dark:bg-dark-200 border border-gray-200 dark:border-dark-300 rounded-lg shadow-lg overflow-hidden z-50">
          <div className="p-2 space-y-1">
            {organizations.map((org) => (
              <button
                key={org.id}
                onClick={() => handleOrgSelect(org.id)}
                className={`w-full text-left px-4 py-2 rounded ${
                  currentOrganization?.id === org.id 
                    ? 'bg-accent-primary/20 text-gray-700 dark:text-accent-primary font-medium'
                    : 'text-gray-700 hover:bg-gray-300/50 dark:text-gray-300 dark:hover:bg-dark-300'
                }`}
              >
                {org.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
} 